import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from '../users.service';


@Component({
  selector: 'app-edit-group',
  templateUrl: './edit-group.component.html',
  styleUrls: ['./edit-group.component.scss']
})
export class EditGroupComponent implements OnInit {

  Form:FormGroup;
  organisationsData:any;

  constructor( private fb:FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<EditGroupComponent>,
    private usersService:UsersService) {
    const d = this.data.data;
    console.log('editing data', d);

    this.Form = this.fb.group({
      name: [d && d.name ? d.name : '', Validators.required],
      // url: [d && d.url ? d.url : '', Validators.required],
      // organisationId: [d && d.organisationId ? d.organisationId : '', Validators.required],
      active: [d && d.active ? d.active : '', Validators.required],
      organisationId: this.data.organisationId,
      // createdAt: new Date()
    });
   }

  ngOnInit(): void {
  }

  async saveBrand(){
    console.log('Brand',this.Form.value);
    // this.spinner.show();
    console.log(this.Form.value);
    console.log(this.data)
    await this.usersService.addEditGroup(this.Form.value,this.data.data?this.data.data.id: '' );
    this.dialogRef.close();
    // this.spinner.hide();
  }

}
